module.exports = __webpack_public_path__ + "img/Formula-new.74ccea55.svg";